import React from 'react';
import IconBase, { iconPropTypes } from '../IconBase';

export default function ConcreteIcon(props) {
	return (
		<IconBase type="concrete" {...props}>
			<path d="M5.5 3H4.5V7H3V8H4.5V12H3V21H21V12H19.5V8H21V7H19.5V3H18.5V7H12.5V3H11.5V7H5.5V3ZM18.5 8V12H12.5V8H18.5ZM5.5 8H11.5V12H5.5V8ZM19.4828 15.3326L17.6624 15.8203L18.1502 14L19.4828 15.3326ZM12.6995 15.296L12.9014 14.0597L13.8711 14.8527L12.6995 15.296ZM9.81086 16.4592L8.7939 17.1907L8.66889 15.9442L9.81086 16.4592ZM15.0633 17.1131L16.2867 16.8437L15.9083 18.0379L15.0633 17.1131ZM7.21573 18.6166L7.15934 19.868L6.10375 19.1935L7.21573 18.6166ZM18.3118 18.5684L19.2816 19.3614L18.11 19.8048L18.3118 18.5684ZM4.5 14.4257L6.41351 14.0735L5.7618 15.9068L4.5 14.4257ZM11.8193 17.9069L13.6986 18.4104L12.3229 19.7862L11.8193 17.9069Z" />
		</IconBase>
	);
}
ConcreteIcon.propTypes = iconPropTypes;
